import {
  getLoading,
  getRoles,
  getToken,
  getTokenAvailable,
  getUserId,
} from "./slice"
import { useSelector } from "@/base/store"

const useAuth = () => ({
  userId: useSelector(getUserId),
  roles: useSelector(getRoles),
  token: useSelector(getToken),
  isLoading: useSelector(getLoading),
  isAuthenticated: useSelector(getTokenAvailable),
})

export default useAuth
